
import Common from "./result-new";
import { Component, Prop, Emit } from "vue-property-decorator";
export default class ResultNewNewH5 extends Common {
  isH5 = true;
}
